/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum JobStatusType {
    Cancelled = 'CANCELLED',
    Error = 'ERROR',
    Finished = 'FINISHED',
    New = 'NEW',
    Running = 'RUNNING',
    Waiting = 'WAITING'
}

export function JobStatusTypeFromJSON(json: any): JobStatusType {
    return JobStatusTypeFromJSONTyped(json, false);
}

export function JobStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobStatusType {
    return json as JobStatusType;
}

export function JobStatusTypeToJSON(value?: JobStatusType | null): any {
    return value as any;
}

